// React bindings for @strava/units
import React, { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import * as unitFormats from './unitFormats.js';

const UnitFormatsContext = createContext(null);

export const UnitFormatsProvider = ({ locale, unitSystem, children }) => {
  const value = useMemo(() => ({ locale, unitSystem }), [locale, unitSystem]);
  return React.createElement(UnitFormatsContext.Provider, { value }, children);
};

UnitFormatsProvider.propTypes = {
  locale: PropTypes.string.isRequired,
  unitSystem: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export const useUnitFormatsContext = () => useContext(UnitFormatsContext);

// BEGIN GENERATED BINDINGS - DO NOT EDIT BELOW THIS POINT
// TO UPDATE, RUN `yarn prepare`
export const Cadence = ({ value, ...options }) => {
  const { locale, unitSystem } = useUnitFormatsContext();
  return unitFormats.formatCadence(locale, unitSystem, value, options);
};

export const Currency = ({ value, ...options }) => {
  const { locale, unitSystem } = useUnitFormatsContext();
  return unitFormats.formatCurrency(locale, unitSystem, value, options);
};

export const DateRange = ({ value, ...options }) => {
  const { locale, unitSystem } = useUnitFormatsContext();
  return unitFormats.formatDateRange(locale, unitSystem, value, options);
};

export const DateTime = ({ value, ...options }) => {
  const { locale, unitSystem } = useUnitFormatsContext();
  return unitFormats.formatDateTime(locale, unitSystem, value, options);
};

export const Distance = ({ value, ...options }) => {
  const { locale, unitSystem } = useUnitFormatsContext();
  return unitFormats.formatDistance(locale, unitSystem, value, options);
};

export const DistancePerTime = ({ value, ...options }) => {
  const { locale, unitSystem } = useUnitFormatsContext();
  return unitFormats.formatDistancePerTime(locale, unitSystem, value, options);
};

export const Elevation = ({ value, ...options }) => {
  const { locale, unitSystem } = useUnitFormatsContext();
  return unitFormats.formatElevation(locale, unitSystem, value, options);
};

export const HeartRate = ({ value, ...options }) => {
  const { locale, unitSystem } = useUnitFormatsContext();
  return unitFormats.formatHeartRate(locale, unitSystem, value, options);
};

export const Number = ({ value, ...options }) => {
  const { locale, unitSystem } = useUnitFormatsContext();
  return unitFormats.formatNumber(locale, unitSystem, value, options);
};

export const Pace = ({ value, ...options }) => {
  const { locale, unitSystem } = useUnitFormatsContext();
  return unitFormats.formatPace(locale, unitSystem, value, options);
};

export const Percent = ({ value, ...options }) => {
  const { locale, unitSystem } = useUnitFormatsContext();
  return unitFormats.formatPercent(locale, unitSystem, value, options);
};

export const Power = ({ value, ...options }) => {
  const { locale, unitSystem } = useUnitFormatsContext();
  return unitFormats.formatPower(locale, unitSystem, value, options);
};

export const StepCadence = ({ value, ...options }) => {
  const { locale, unitSystem } = useUnitFormatsContext();
  return unitFormats.formatStepCadence(locale, unitSystem, value, options);
};

export const SwimDistance = ({ value, ...options }) => {
  const { locale, unitSystem } = useUnitFormatsContext();
  return unitFormats.formatSwimDistance(locale, unitSystem, value, options);
};

export const SwimPace = ({ value, ...options }) => {
  const { locale, unitSystem } = useUnitFormatsContext();
  return unitFormats.formatSwimPace(locale, unitSystem, value, options);
};

export const Temperature = ({ value, ...options }) => {
  const { locale, unitSystem } = useUnitFormatsContext();
  return unitFormats.formatTemperature(locale, unitSystem, value, options);
};

export const Timespan = ({ value, ...options }) => {
  const { locale, unitSystem } = useUnitFormatsContext();
  return unitFormats.formatTimespan(locale, unitSystem, value, options);
};

export const Weight = ({ value, ...options }) => {
  const { locale, unitSystem } = useUnitFormatsContext();
  return unitFormats.formatWeight(locale, unitSystem, value, options);
};
